import { render, staticRenderFns } from "./Ip.Detail.vue?vue&type=template&id=6b9febc5&"
import script from "./Ip.Detail.vue?vue&type=script&lang=js&"
export * from "./Ip.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports